import ScrollReveal from "../../../components/feature/ScrollReveal";
import { useGiftData } from "../../../lib/useMockData";

export default function FlowSection() {
  const { flowData } = useGiftData();
  return (
    <section className="py-20 md:py-28 bg-airdoa-cream">
      <div className="px-4 md:px-8 lg:px-12">
        <div className="max-w-5xl mx-auto">
          <ScrollReveal direction="up">
            <div className="text-center mb-12 md:mb-16">
              <p className="section-label mb-2">{flowData.label}</p>
              <h2 className="section-title">{flowData.title}</h2>
            </div>
          </ScrollReveal>

          <div className="relative">
            {/* connector line */}
            <div className="hidden md:block absolute left-1/2 top-8 bottom-8 w-px bg-airdoa-gray-light/60 -translate-x-1/2" />

            <div className="space-y-8 md:space-y-0">
              {flowData.steps.map((step, idx) => (
                <ScrollReveal
                  key={step.num}
                  direction="up"
                  delay={idx * 120}
                >
                  <div
                    className={`relative flex flex-col md:flex-row items-center gap-6 md:gap-10 ${
                      idx % 2 === 1 ? "md:flex-row-reverse" : ""
                    }`}
                  >
                    {/* number + icon circle */}
                    <div className="relative z-10 w-16 h-16 md:w-20 md:h-20 shrink-0 flex flex-col items-center justify-center rounded-full bg-airdoa-navy text-airdoa-gold">
                      <span className="text-[10px] font-bold tracking-ultra">
                        STEP
                      </span>
                      <span className="text-lg font-serif font-bold leading-none">
                        {step.num}
                      </span>
                    </div>

                    {/* content */}
                    <div className="flex-1 text-center md:text-left bg-white rounded-lg p-6 md:p-8 border border-airdoa-gray-light/30">
                      <div className="flex items-center justify-center md:justify-start gap-2 mb-2">
                        <span className="w-5 h-5 flex items-center justify-center text-airdoa-gold">
                          <i className={`${step.icon}`} />
                        </span>
                        <h3 className="text-base font-serif font-semibold text-airdoa-navy">
                          {step.title}
                        </h3>
                      </div>
                      <p className="text-sm text-airdoa-gray leading-relaxed">
                        {step.desc}
                      </p>
                    </div>
                  </div>
                </ScrollReveal>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}